import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from '@3plearning/react-components';
import { withRouter } from 'react-router-dom';
import portalCommunication from '@3plearning/mathletics-portal-communication-service';

import css from './empty-state.scss';

import EMPTY_STATE_VARIANTS from './empty-state-constants';
import {
    CLASS_LIST,
    SELECTED_CLASS,
    SELECTED_REPORT
} from '../report-filters/filter-constants';
import { activeFiltersPropType } from '../report-filters/filter-prop-types';
import activeFiltersSelectors from '../report-filters/redux/active-filters/active-filters-selectors';
import { getTranslationKey } from '../../helpers/locale-helpers';

import {
    getConfiguration,
    getHasNoStudents,
    isEmptyArray
} from '../../helpers/utils';
import { PORTAL_MODULE } from '../../helpers/constants';
import dropdownDataSelectors from '../report-filters/redux/dropdown-data/dropdown-data-selectors';

import PageHeader from '../page-header/page-header';
import TableHeader from '../table-header/table-header';
import SubHeadingHeader from '../sub-heading/sub-heading-header/sub-heading-header';

/**
 * EMPTY STATE
 * --------------------
 * HOC which manages empty state of variants. Currently one use case but can be extended to fit multiple
 */
class EmptyState extends Component {
    static propTypes = {
        // redux filter values
        activeFilters: activeFiltersPropType,
        // Manages loading state
        busyIndicatorCount: PropTypes.number,
        // Class data used to manage No Classes variant
        classDropdownData: PropTypes.object,
        // Children node
        children: PropTypes.node,
        // Variant types
        variant: PropTypes.oneOf([
            EMPTY_STATE_VARIANTS.DEFAULT,
            EMPTY_STATE_VARIANTS.NO_CLASSES,
            EMPTY_STATE_VARIANTS.NO_STUDENTS
        ])
    };

    constructor(props) {
        super(props);
        this.state = {
            hasNoStudents: false
        };
        this.text = {
            noClassesHeader: 'Empty State - No classes assigned',
            noClassesContent:
                'Empty State - Please contact your school administration',
            noStudentsContent1: 'Table Empty - No students in this class',
            noStudentsContent2: 'Progress Display - Dash Label',
            noStudentsContent3: 'Table Empty - Go to Manage Students'
        };
    }

    getHasNoStudents = (props) => {
        const { variant } = props;
        if (variant === EMPTY_STATE_VARIANTS.NO_STUDENTS) {
            return getHasNoStudents(props.activeFilters, props.allClasses);
        }

        return false;
    };

    getEmptyState = () => {
        const { variant } = this.props;
        const i18n = window.i18n;
        switch (variant) {
            case EMPTY_STATE_VARIANTS.NO_CLASSES: {
                const { noClassesHeader, noClassesContent } = this.text;
                const {
                    children,
                    classDropdownData,
                    busyIndicatorCount
                } = this.props;
                const showEmptyState =
                    classDropdownData &&
                    isEmptyArray(classDropdownData.data) &&
                    busyIndicatorCount === 0;

                if (showEmptyState) {
                    return (
                        <div className={css['empty-state']}>
                            <PageHeader showFilters={false} />
                            <Container className={css['container-wrapper']}>
                                <div className={css['no-classes']}>
                                    <h3 className={css['no-classes-header']}>
                                        {i18n._(noClassesHeader)}
                                    </h3>
                                    <span className={css['no-classes-content']}>
                                        {i18n._(noClassesContent)}
                                    </span>
                                </div>
                            </Container>
                        </div>
                    );
                }

                return <div>{children}</div>;
            }
            case EMPTY_STATE_VARIANTS.NO_STUDENTS: {
                const { activeFilters, children } = this.props;
                const hasNoStudents = this.getHasNoStudents(this.props);
                const {
                    noStudentsContent1,
                    noStudentsContent2,
                    noStudentsContent3
                } = this.text;
                let tableHeaderTitle = activeFilters[SELECTED_REPORT].name;
                tableHeaderTitle = getTranslationKey(tableHeaderTitle);
                const classId = activeFilters[SELECTED_CLASS].id;
                if (hasNoStudents) {
                    return (
                        <div className={css['empty-state']}>
                            <TableHeader
                                title={tableHeaderTitle}
                                showButton
                                translate
                            />
                            <SubHeadingHeader />
                            <div className={css['no-students-content']}>
                                <div className={css.text}>
                                    {i18n._(noStudentsContent1)}
                                </div>
                                <div className={css.text}>
                                    {i18n._(noStudentsContent2)}
                                </div>
                                <button
                                    className={css['manage-students-button']}
                                    onClick={async () => {
                                        const moduleId = await getConfiguration(
                                            PORTAL_MODULE.MANAGE_STUDENTS
                                        );
                                        portalCommunication.requestModuleChange(
                                            moduleId,
                                            {
                                                classId
                                            }
                                        );
                                    }}
                                >
                                    {i18n._(noStudentsContent3)}
                                </button>
                            </div>
                        </div>
                    );
                }

                return children;
            }
            default: {
                const { children } = this.props;

                return children;
            }
        }
    };

    render() {
        return this.getEmptyState();
    }
}

function mapStateToProps(state) {
    return {
        allClasses: state.allClasses,
        activeFilters: activeFiltersSelectors.selectActiveFilters(state),
        busyIndicatorCount: state.busyIndicatorCount,
        classDropdownData: dropdownDataSelectors.selectDropdownDataByType(
            CLASS_LIST
        )(state)
    };
}

export default withRouter(connect(mapStateToProps)(styleable(css)(EmptyState)));



// WEBPACK FOOTER //
// ./components/empty-state/empty-state.js